module.exports = __webpack_public_path__ + "img/720.fb5627cd.svg";